
import { Game } from '../types';

export const mockGames: Game[] = [
  {
    id: 'ryuutama',
    name: 'りゅうたま',
    summary: '旅をテーマにした心温まるテーブルトークRPG。プレイヤーは旅人となり、美しい世界を冒険します。',
    coverImage: 'https://m.media-amazon.com/images/I/91bKJaalziS.jpg',
    status: 'published' as const,
    rules: 'https://atwiki.jp/ryuutama/',
    tags: ['TRPG'], // TRPGタグを追加
    faq: [
      {
        id: '1',
        question: 'ゲーム開始の準備は何が必要ですか？',
        answer: 'りゅうたまを始めるには、ルールブック、キャラクターシート、ダイス（d4、d6、d8、d10、d12、d20）、筆記用具が必要です。また、GMが物語を準備しておくことも重要です。'
      },
      {
        id: '2',
        question: '同点の場合の勝敗判定はありますか？',
        answer: 'りゅうたまは協力型のRPGなので、基本的に勝敗という概念はありません。プレイヤー全員で物語を作り上げることが目的です。'
      },
      {
        id: '3',
        question: 'VRChatでりゅうたまを楽しむ方法は？',
        answer: 'VRChatでりゅうたまを楽しむには、専用のワールドを検索してください。ボイスチャット機能を使ってロールプレイを行うことができます。'
      }
    ],
    vrcGuide: {
      text: 'VRChatでりゅうたまを楽しむためのガイドです。',
      url: 'https://vrchat.com/home/world/wrld_example',
      images: []
    },
    instanceGuide: {
      text: 'りゅうたまのインスタンス作成ガイドです。',
      images: []
    },
    sources: [
      {
        id: 'source1',
        type: 'url',
        name: 'りゅうたま公式Wiki',
        ref: 'https://atwiki.jp/ryuutama/',
        page: 'メインページ'
      }
    ],
    metadata: {
      targetAge: '10歳以上',
      playerCount: '2-5人',
      playTime: '2-4時間',
      version: 'v1.0'
    }
  },
  {
    id: 'catan',
    name: 'カタン',
    summary: '無人島を開拓する戦略ボードゲーム。資源を集めて街道や都市を建設し、島の覇者を目指します。',
    coverImage: 'https://readdy.ai/api/search-image?query=Catan%20board%20game%20with%20hexagonal%20tiles%2C%20settlements%2C%20roads%2C%20resource%20cards%2C%20strategic%20gameplay%2C%20colorful%20board%20game%20components%2C%20simple%20background&width=400&height=250&seq=catan-cover&orientation=landscape',
    status: 'published' as const,
    rules: 'https://www.catan.jp/rules/',
    tags: ['ボードゲーム'], // ボードゲームタグを追加
    faq: [
      {
        id: '1',
        question: 'ゲーム開始の準備は何が必要ですか？',
        answer: 'カタンを始めるには、ゲームボード、資源カード、建設コスト表、ダイス2個、盗賊コマ、各プレイヤーの建物コマが必要です。'
      },
      {
        id: '2',
        question: '同点の場合の勝敗判定はどうなりますか？',
        answer: 'カタンでは10点に最初に到達したプレイヤーが勝利します。同時に10点に到達した場合は、そのターンのプレイヤーが勝利となります。'
      }
    ],
    vrcGuide: {
      text: 'VRChatでカタンを楽しむためのガイドです。',
      url: 'https://vrchat.com/home/world/wrld_catan',
      images: []
    },
    instanceGuide: {
      text: 'カタンのインスタンス作成ガイドです。',
      images: []
    },
    sources: [
      {
        id: 'source1',
        type: 'url',
        name: 'カタン公式サイト',
        ref: 'https://www.catan.jp/',
        page: 'ルール説明'
      }
    ],
    metadata: {
      targetAge: '10歳以上',
      playerCount: '3-4人',
      playTime: '60-90分',
      version: 'v1.0'
    }
  },
  {
    id: 'splendor',
    name: 'スプレンダー',
    summary: '宝石商となって富と名声を築く戦略カードゲーム。効率的な宝石の収集と建物の建設が勝利の鍵です。',
    coverImage: 'https://readdy.ai/api/search-image?query=Splendor%20card%20game%20with%20colorful%20gems%2C%20elegant%20cards%2C%20merchant%20theme%2C%20luxury%20jewels%2C%20strategic%20card%20game%20components%2C%20simple%20background&width=400&height=250&seq=splendor-cover&orientation=landscape',
    status: 'published' as const,
    rules: 'https://hobbyjapan.co.jp/game/splendor/',
    tags: ['ボードゲーム'], // ボードゲームタグを追加
    faq: [
      {
        id: '1',
        question: 'ゲーム開始の準備は何が必要ですか？',
        answer: 'スプレンダーを始めるには、発展カード、宝石トークン、貴族タイルが必要です。プレイヤー人数に応じて宝石トークンの数を調整してください。'
      },
      {
        id: '2',
        question: '同点の場合の勝敗判定はどうなりますか？',
        answer: 'スプレンダーでは15点に到達したプレイヤーが勝利しますが、同点の場合は発展カードの枚数が少ないプレイヤーが勝利します。'
      }
    ],
    vrcGuide: {
      text: 'VRChatでスプレンダーを楽しむためのガイドです。',
      url: 'https://vrchat.com/home/world/wrld_splendor',
      images: []
    },
    instanceGuide: {
      text: 'スプレンダーのインスタンス作成ガイドです。',
      images: []
    },
    sources: [
      {
        id: 'source1',
        type: 'url',
        name: 'ホビージャパン公式',
        ref: 'https://hobbyjapan.co.jp/game/splendor/',
        page: 'ゲーム紹介'
      }
    ],
    metadata: {
      targetAge: '10歳以上',
      playerCount: '2-4人',
      playTime: '30分',
      version: 'v1.0'
    }
  },
  // デモゲーム（全てボードゲームタグ）
  {
    id: 'demo-game-1',
    name: 'デモゲーム1',
    summary: 'これはデモ用のサンプルゲームです。実際のゲーム情報ではありません。',
    coverImage: 'https://readdy.ai/api/search-image?query=demo%20board%20game%20with%20colorful%20pieces%2C%20game%20board%2C%20cards%2C%20family%20friendly%2C%20simple%20background&width=400&height=250&seq=demo1-cover&orientation=landscape',
    status: 'published' as const,
    rules: '',
    tags: ['ボードゲーム'], // デモゲームもボードゲームタグ
    faq: [],
    vrcGuide: { text: '', url: '', images: [] },
    instanceGuide: { text: '', images: [] },
    sources: [],
    metadata: {
      targetAge: '8歳以上',
      playerCount: '2-6人',
      playTime: '45分',
      version: 'demo'
    }
  },
  {
    id: 'demo-game-2',
    name: 'デモゲーム2',
    summary: 'これはデモ用のサンプルゲームです。実際のゲーム情報ではありません。',
    coverImage: 'https://readdy.ai/api/search-image?query=demo%20strategy%20board%20game%20with%20wooden%20pieces%2C%20game%20tiles%2C%20player%20boards%2C%20modern%20design%2C%20simple%20background&width=400&height=250&seq=demo2-cover&orientation=landscape',
    status: 'published' as const,
    rules: '',
    tags: ['ボードゲーム'], // デモゲームもボードゲームタグ
    faq: [],
    vrcGuide: { text: '', url: '', images: [] },
    instanceGuide: { text: '', images: [] },
    sources: [],
    metadata: {
      targetAge: '12歳以上',
      playerCount: '3-5人',
      playTime: '60分',
      version: 'demo'
    }
  },
  {
    id: 'demo-game-3',
    name: 'デモゲーム3',
    summary: 'これはデモ用のサンプルゲームです。実際のゲーム情報ではありません。',
    coverImage: 'https://readdy.ai/api/search-image?query=demo%20card%20board%20game%20with%20colorful%20cards%2C%20tokens%2C%20game%20components%2C%20casual%20gaming%2C%20simple%20background&width=400&height=250&seq=demo3-cover&orientation=landscape',
    status: 'published' as const,
    rules: '',
    tags: ['ボードゲーム'], // デモゲームもボードゲームタグ
    faq: [],
    vrcGuide: { text: '', url: '', images: [] },
    instanceGuide: { text: '', images: [] },
    sources: [],
    metadata: {
      targetAge: '10歳以上',
      playerCount: '2-4人',
      playTime: '30分',
      version: 'demo'
    }
  }
];
